import React from 'react';
import { Container } from 'react-bootstrap';
import styles from './bodywon.module.css';
import { useSettings } from '../context/SettingsContext';
import { getSettingValue } from '../utils/settingsStorefront';

const TopBar = () => {
  const { settings } = useSettings();
  const flashBanner = getSettingValue(settings, 'FlashBanner');

  if (!String(flashBanner || '').trim()) {
    return null;
  }

  return (
    <div className={styles.topBar}>
      <Container className={styles.topBarContainer}>
        <p className={styles.topBarText}>{flashBanner}</p>
      </Container>
    </div>
  );
};

export default TopBar;
